import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Search: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.334 15.5a6.667 6.667 0 115.266-2.579l4.49 4.49-1.179 1.178-4.49-4.49A6.638 6.638 0 018.335 15.5zm0-1.667a5 5 0 100-10 5 5 0 000 10z"
        fill={color}
      />
    </svg>
  );
};

export default Search;
